var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSbp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.09601 8.46875L8.32507 14.2395V17.7595L5.09979 23.5189L5.09601 8.46875Z",
    fill: "#5B57A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4957 12.1334L20.5215 10.2792L26.7139 10.2734L17.4957 15.9196V12.1334Z",
    fill: "#D90751"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.477 8.43304L17.4941 16.0733L14.2574 14.0849V2.66406L17.477 8.43304Z",
    fill: "#FAB718"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7122 10.2779L20.5196 10.2837L17.477 8.43304L14.2574 2.66406L26.7122 10.2779Z",
    fill: "#ED6F26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4941 23.5559V19.8491L14.2574 17.8984L14.2592 29.3306L17.4941 23.5559Z",
    fill: "#63B22F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5125 21.7136L8.32485 14.2395L5.09601 8.46875L26.6993 21.706L20.5125 21.7136Z",
    fill: "#1487C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2601 29.3227L17.4945 23.548L20.5127 21.7107L26.6995 21.7031L14.2601 29.3227Z",
    fill: "#017F36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1012 23.5116L14.2855 17.8864L11.1978 15.9922L8.32648 17.7522L5.1012 23.5116Z",
    fill: "#984995"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSbp);
export default __webpack_public_path__ + "static/media/iconSBP.254328a4096f27360a1963ecb17571cc.svg";
export { ForwardRef as ReactComponent };